'use strict';

import fragment from './duotoneFragment.glsl';

var DuotoneFilter = function (u_colorA, u_colorB, u_colorT, u_colorApos, u_colorBpos, u_brightness, u_contrast) {  

  // defaults:
  u_brightness = u_brightness || -0.2;
  u_contrast = u_contrast || 0.65;

  u_colorA = u_colorA || [132/255, 204/255, 242/255, 1.0];
  u_colorB = u_colorB || [200/255, 163/255, 255/255, 1.0];
  u_colorT = u_colorT || [104/255, 23/255, 154/255, 1.0];

  u_colorApos = u_colorApos || [0.0, 0.0];
  u_colorBpos = u_colorBpos || [1.0, 1.0];


  PIXI.AbstractFilter.call(this, 
    // vertex shader
    null,
    // fragment shader
    [ fragment ],
    // custom unifroms
    {
      
      // colorA: { type: '4f', value: [1.0, 0.25490196078431, 0.41176470588235, 1.0] },
      // colorB: { type: '4f', value: [0.4078431372549, 0.09019607843137, 0.60392156862745, 1.0] }

      // colorA: { type: '4f', value: [132/255, 248/255, 210/255, 1.0] },
      // colorB: { type: '4f', value: [163/255, 33/255, 82/255, 1.0] },

      // colorA: { type: '4f', value: [235/255, 30/255, 50/255, 1.0] },
      // colorB: { type: '4f', value: [36/255, 33/255, 106/255, 1.0] }

      u_colorA: { type: '4f', value: u_colorA },
      u_colorB: { type: '4f', value: u_colorB },
      u_colorT: { type: '4f', value: u_colorT },
      
      u_colorApos : {type: '2f' , value: u_colorApos},
      u_colorBpos : {type: '2f' , value: u_colorBpos},

      u_brightness: {type: '1f' , value: u_brightness },
      u_contrast: {type: '1f' , value: u_contrast }
    }
  );


};

DuotoneFilter.prototype = Object.create(PIXI.AbstractFilter.prototype);
DuotoneFilter.prototype.constructor = DuotoneFilter;

Object.defineProperties(DuotoneFilter.prototype, {
  u_colorA : {
    set: function (rgba) {
      this.uniforms.u_colorA.value = rgba;
      this.dirty = true;
    },

    get: function() {
      return this.uniforms.u_colorA.value;
    }
    
  },
  
  u_colorB : {
    set: function (rgba) {
      this.uniforms.u_colorB.value = rgba;
      this.dirty = true;
    },

    get: function() {
      return this.uniforms.u_colorB.value;
    }
  },

  u_colorT : {
    set: function (rgba) {
      this.uniforms.u_colorT.value = rgba;
      this.dirty = true;
    },

    get: function() {
      return this.uniforms.u_colorT.value;
    }
  },
  
  u_colorApos : {
    set: function (value) {
      this.uniforms.u_colorApos.value = value;
      this.dirty = true;
    },
    get : function() {
      return this.uniforms.u_colorApos.value;
    }
  },

  u_colorBpos : {
    set: function (value) {
      this.uniforms.u_colorBpos.value = value;
      this.dirty = true;
    },
    get : function() {
      return this.uniforms.u_colorBpos.value;
    }
  },

  u_brightness : {
    set: function (brightness) {
      this.uniforms.u_brightness.value = brightness;
      this.dirty = true;
    },

    get: function() {
      return this.uniforms.u_brightness.value;
    }
  },

  u_contrast : {
    set: function (contrast) {
      this.uniforms.u_contrast.value = contrast;
      this.dirty = true;
    },

    get: function() {
      return this.uniforms.u_contrast.value;
    }
  }

});

module.exports = DuotoneFilter;


/** WEBPACK FOOTER **
 ** ./src/js/views/shaders/duotone.js
 **/